<script setup lang="ts">
import type { ColorPair } from '~/models/Presentation/BasePage'
import type { Image } from '~/models/Content/Image'
import { computed } from 'vue'
import { faCopyright } from '@fortawesome/duotone-regular-svg-icons'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'

const props = defineProps<{
  image?: Image
  classes?: string | string[]
  colorPair?: ColorPair
  copyright?: string
  caption?: string
}>()

const src = computed(() => props.image?.src)
const altText = computed(() => props.image?.altText)
const _copyright = computed(() => props.copyright ?? props.image?.copyright)
const _caption = computed(() => props.caption ?? props.image?.caption)
</script>

<template>
  <div class="group relative size-full">
    <slot>
      <img
        v-if="src"
        :src="src"
        :alt="altText"
        :class="classes"
      >
    </slot>

    <div
      v-if="_copyright || _caption"
      class="absolute bottom-0 w-max max-w-prose space-y-1 bg-blue-50 px-6 py-3 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100"
      :style="{ background: colorPair?.text, color: colorPair?.background }"
    >
      <RichTextRenderer
        v-if="_caption"
        :text="_caption"
      />
      <small
        v-if="_copyright"
        data-ignore-tts
        class="flex items-center gap-2 text-sm"
      >
        <font-awesome-icon :icon="faCopyright" size="lg" />
        <span v-text="_copyright" />
      </small>
    </div>
  </div>
</template>
